import API from '@/util/api/API'
import { APIResponse } from '@/types/api/api'
import { Preference } from '@/store/settings/types'

class SettingsAPI {
    public async updateEmail(email: string): Promise<APIResponse> {
        return API.post('settings/email', { email })
    }

    public async updateUsername(username: string): Promise<APIResponse> {
        return API.post('settings/username', { username })
    }

    public async updatePreference(
        type: string, key: string, value: any
    ): Promise<Preference | APIResponse> {
        return API.put(`preferences/${type}/${key}`, { value })
    }

    public async getPreferences(type?: string, key?: string): Promise<Preference[]> {
        return (await API.get(`preferences${type ? `/${type}${key ? `${key}`: ''}` : ''}`))
            .map((pref: any) => ({ ...pref, value: JSON.parse(pref.value) }))
    }
}

export default new SettingsAPI()
